// vim: ft=javascriptreact
import React, { useEffect, useContext } from 'react'
import { Routes, Route, Link, useNavigate } from 'react-router-dom'
import {
  Container,
  Image,
  Nav,
  Navbar,
} from 'react-bootstrap';
import './App.scss';
//import './App.css';
import { Amplify, Auth, Hub } from 'aws-amplify';
import '@aws-amplify/ui-react/styles.css';
import useApiRequest from './hooks/useApiRequest';
import useResident from './hooks/useResident';
import { ImperialBookingContext } from './context/ImperialBookingContext';
import AuthChecker from './AuthChecker';
import LandingPage from './LandingPage';
import VerifyPhoneNumberBanner from './VerifyPhoneNumberBanner';
import Home from './Home';
import MyAccount from './MyAccount';
import Schedule from './Schedule/index';
import BookingForm from './BookingForm/';
//import PaymentForm from './PaymentForm/'
import Terms from './Terms';
import CleanUp from './CleanUp';
import Admin from './Admin/index';
import BookingsListing from './Admin/BookingsListing';
import ResidentsListing from './Admin/ResidentsListing';
import ResidentViewer from './Admin/ResidentViewer';

import Redirector from './Redirector';

import NotFound from './NotFound';
import logo from './imerial-logo.png';

import { I18n } from 'aws-amplify';
import { translations } from '@aws-amplify/ui-react';

// TODO: migrate away from this file
import awsExports from './aws-exports'
awsExports['aws_user_pools_id'] = `${process.env.REACT_APP_USERPOOL_ID}`;
awsExports['aws_user_pools_web_client_id'] = `${process.env.REACT_APP_USERPOOL_CLIENT_ID}`;
awsExports['oauth']['domain'] = `${process.env.REACT_APP_OAUTH_DOMAIN}`;
awsExports['oauth']['redirectSignIn'] = `${process.env.REACT_APP_OAUTH_REDIRECT_SIGN_IN}`;
awsExports['oauth']['redirectSignOut'] = `${process.env.REACT_APP_OAUTH_REDIRECT_SIGN_OUT}`;
Amplify.configure(awsExports)

I18n.putVocabularies(translations);
I18n.setLanguage('en');
I18n.putVocabulariesForLanguage('en', {
  'Create Account': 'Sign Up',
  'Given Name': 'First Name',
  'Family Name': 'Last Name',
})

const listener = (data: any) => {
  if (!!process.env.REACT_APP_DEBUG) {
    console.log("Master listener", data.payload.event, data)
  }
  switch (data.payload.event) {
    case 'signIn_failure':
      console.log('got a signIn_failure')
      setTimeout(() => {
        Hub.dispatch('custom', data.payload, 'App.js')
      }, 1000)
  }
}

Hub.listen('auth', listener)

if (!!process.env.REACT_APP_DEBUG) {
  window._Hub = Hub
}

const FacebookRedirector = ({ path }: { path: string }) : JSX.Element => {
  const {
    setShowFacebook,
  } = useContext(ImperialBookingContext);

  useEffect(() => {
    setShowFacebook(true)
  }, []);

  return <Redirector path={path} />
}

function App() {
  const { apiGet } = useApiRequest()
  const {
    user,
    resident,
    accessToken,
    admin,
    setAdmin,
    nonResident,
    setNonResident,
    resetContext,
  } = useContext(ImperialBookingContext)
  const { fetchResident } = useResident()
  const navigate = useNavigate()

  const onSignOut = () => {
    navigate('/')
    resetContext()
    Auth.signOut()
  }

  //const location = useLocation()
  //window.user = cognitoUser
  //const accessToken = user.getSignInUserSession().getAccessToken().getJwtToken()
  //useEffect(() => {
  //  //console.log("Setting cognitoUser", cognitoUser)
  //  setCognitoUser(cognitoUser)
  //}, [cognitoUser])

  useEffect(() => {
    if (accessToken) {
      fetchResident()

      apiGet('groups')
        .then((payload) => {
          if (payload.is_admin) {
            setAdmin(true)
          }
          if (payload.is_non_resident) {
            setNonResident(true)
          }
        })
    }
  }, [accessToken])

  // When a user is invited, we don't get their attributes
  useEffect(() => {
    if (user && !user.attributes) {
      navigate(`/`)
      window.location.reload()
      //user.getUserAttributes((error, attributes) => {
      //  user.attributes = attributes.reduce((memo, attr) => {
      //    memo[attr.Name] = attr.Value
      //    return memo
      //  }, {})

      //  setCognitoUser(user)
      //})
    }
  }, [user])

  //if (!user || (user && !user.attributes) || !accessToken) {
  //  return (
  //    <AuthChecker>
  //      <Spinner animation="border" role="status">
  //        <span className="visually-hidden">Loading...</span>
  //      </Spinner>
  //    </AuthChecker>
  //  )
  //}

  return (
    <>
      <AuthChecker />
      <Navbar collapseOnSelect expand="md" bg="dark" variant="dark" fixed="top">
        <Container fluid>
          <Navbar.Brand>
            <a href="/"><Image src={logo} width={58} height={42} /></a>
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav>
              {user && <Nav.Link to="/account" as={Link}>My Account</Nav.Link>}
              {user && !nonResident && <Nav.Link to="/" as={Link}>{resident ? 'My Bookings' : 'Finish Sign Up'}</Nav.Link>}
              {user && <Nav.Link to="/schedule" as={Link}>Room Schedule</Nav.Link>}
              <Nav.Link to="/terms" as={Link}>Terms</Nav.Link>
              <Nav.Link to="/clean-up" as={Link}>Clean-Up Checklist</Nav.Link>
              {user && <a className="nav-link" href="https://imperial:87units@theimperialstrata.com/strata/minutes/" target="_blank">Strata Minutes and Documents</a>}
              {admin && <Nav.Link to="/admin/bookings" as={Link}>Admin</Nav.Link>}
              {user && <Nav.Link onClick={onSignOut}>Sign Out</Nav.Link>}
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      <LandingPage />

      <Container fluid="lg" className="imperial-content">
        <Routes>
          <Route path="/" element={<><VerifyPhoneNumberBanner /><Home /></>} />
          <Route path="/facebook" element={<FacebookRedirector path="/" />} />
          <Route path="/account" element={<MyAccount />} />
          <Route path="/auth/:authStage" element={<Home />} />
          <Route path="/schedule" element={<><VerifyPhoneNumberBanner /><Schedule /></>} />
          {resident && <Route path="/book/:date" element={<BookingForm />} />}
          <Route path="/terms" element={<Terms />} />
          <Route path="/clean-up" element={<CleanUp />} />
          <Route path="/admin" element={<Admin />}>
            <Route path="bookings" element={<BookingsListing />}/>
            <Route path="bookings/confirm/:bookingId" element={<BookingsListing />} />
            <Route path="residents" element={<ResidentsListing />}/>
            <Route path="residents/:residentId" element={<ResidentViewer />}/>
            <Route path="*" element={<Redirector path="/admin/bookings" />} />
          </Route>
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Container>
    </>
  );
}

export default App
